import React, { useState } from 'react';
import Styles from './MaoNaRoda25Banner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function MaoNaRoda25Banner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="mao-na-roda-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 450 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-450.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-450.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-450.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
              {width > 450 && width <= 600 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-600.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-600.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-600.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
              {width > 600 && width <= 800 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-800.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-800.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-800.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
              {width > 800 && width <= 1280 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-1280.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-1280.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-1280.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-1360.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-1360.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-1360.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
              {width > 1360 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/mao-na-roda-25/hero/hero-1920.webp" /> */}
                  <source type="image/png" srcSet="assets/mao-na-roda-25/hero/hero-1920.png" />
                  <img
                    src="assets/mao-na-roda-25/hero/hero-1920.png"
                    alt="Cliente recebendo atendimento para seguro automóvel em concessionária com veículo financiado no Santander."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Mão na Roda</h1>
              <p className="alt-text">
                Conheça nossas opções de seguros para veículos e proteção financeira.
                <br />
                Conte com opções facilitadas e especiais, além de uma contratação simples e a
                cobertura perfeita para você e sua família.
              </p>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default MaoNaRoda25Banner;
